import(/* webpackMode: "eager" */ "/repo/apps/dashboard/app/global-error.tsx");
